// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"SectionButton_loadingSpinner__3A6kt","sectionButton":"SectionButton_sectionButton__GNJy9"};